module.exports = __webpack_public_path__ + "img/IMG_0188_f4db0565ff.3a9b3c91.webp";